// extracted by mini-css-extract-plugin
export default {"loading":"loading-dots_loading__ceAj6","spacer":"loading-dots_spacer__Wsk9O","blink":"loading-dots_blink__GYbGf"};